import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import LoadingUI from "@/componentsUI/LoadingUI/LoadingUI";
import TabsPlusButtonUI from "@/componentsUI/TabsPlusUI/TabsPlusButtonUI/TabsPlusButtonUI";
import TabsPlusUI from "@/componentsUI/TabsPlusUI/TabsPlusUI";
import CurrencyExchange from "@/pages/wallet/exchange/CurrencyExchange";
import Recharge from "@/pages/wallet/recharge/Recharge";
import Withdraw from "@/pages/wallet/withdraw/Withdraw";
import { useWalletAll } from "@/store/walletStore";
import { useUserInfo } from "@/store/userInfo";
import { useWithdrawalEntryPrompt } from "@/features/install/withdrawalOfficialAppPrompt";
import React, { useState, useEffect } from "react";
import { subscribeWalletTabIntent } from "./walletTabIntent";
import "./index.less";
const enum WalletTypeKey {
  Recharge = 0, //'Deposit',
  Excharge = 1, //'Swap',
  WithDarw = 2, //'Withdraw',
}

const Wallet = () => {
  const { t } = useTranslationPlus("Wallet");
  const { data, isLoading, error, mutate } = useWalletAll();
  const { data: userInfo } = useUserInfo();

  // 检查是否有指定的活跃选项卡
  function getInitialTab() {
    const savedTab = localStorage.getItem("walletActiveTab");
    if (savedTab) {
      // 使用后需要清除，避免下次打开还是进入提现界面
      localStorage.removeItem("walletActiveTab");
      return parseInt(savedTab);
    }
    return WalletTypeKey.Recharge; // 默认显示充值选项卡
  }

  const [activeTab, setActiveTab] = useState<number>(getInitialTab());

  useEffect(
    () => subscribeWalletTabIntent((tabIndex) => setActiveTab(tabIndex)),
    [],
  );

  useWithdrawalEntryPrompt(activeTab, userInfo?.userId);

  return (
    <div className="wallet-mobile-content">
      <div className="fixed-header">
        <div className={`mobile-wallet-Tit`}>
          <TabsPlusUI
            interval={1}
            defaultValue={activeTab}
            onSelect={(v) => {
              setActiveTab(v);
            }}
          >
            <TabsPlusButtonUI
              index={WalletTypeKey.Recharge}
              title={t("Deposit")}
            />
            {data?.swap?.length > 1 && (
              <TabsPlusButtonUI
                index={WalletTypeKey.Excharge}
                title={t("Swap")}
              />
            )}
            <TabsPlusButtonUI
              index={WalletTypeKey.WithDarw}
              title={t("Withdraw")}
            />
          </TabsPlusUI>
        </div>
      </div>
      <div className={"scorllview"}>
        <LoadingUI
          isLoading={isLoading}
          error={error}
          retryFunc={mutate}
          dataList={data}
        >
          {activeTab === WalletTypeKey.Recharge && <Recharge />}
          {activeTab === WalletTypeKey.Excharge && <CurrencyExchange />}
          {activeTab === WalletTypeKey.WithDarw && <Withdraw />}
        </LoadingUI>
      </div>
    </div>
  );
};

export default Wallet;
